// ref: https://mouseflow.freshdesk.com/support/solutions/articles/44001534807-exclude-or-replace-content-on-pages
// usage: data-mf-replace-inner={MFSDR}
/*
  @Cheat Sheet
  In chrome console, `$$('[data-mf-replace-inner]')` to find all elements with sensitive elements

  add style to make them red

  [data-mf-replace-inner] {
    color: red;
  }

  or from console directly
  $$('[data-mf-replace-inner]').map(el=> el.style="background-color: red")
*/
export const MFSDR = `**HIDDEN**`
